import { Page } from './page';
import { SupportedChatChannel } from '../chats/supportedChatChannel';

export enum ChatMessagePayloadType {
  IMAGE = 'image',
  VIDEO = 'video',
  DOC = 'document',
  TEXT = 'text',
  TEXT_BUTTON = 'text_button',
  IMAGE_BUTTON = 'image_button',
  UNSUPPORTED = 'unsupported',
  BUTTON = 'button',
  // AUDIO = 'audio',
  // CONTACT = 'contact',
}

export enum ChatMessageStatus {
  NEW = 'NEW',
  SENDING = 'SENDING',
  QUEUED = 'QUEUED',
  SENT = 'SENT',
  UNREAD = 'UNREAD',
  READ = 'READ',
  DELIVERED = 'DELIVERED',
  UNDELIVERED = 'UNDELIVERED',
  BLOCKED_NOT_IN_PACKAGE = 'BLOCKED_NOT_IN_PACKAGE',
  NOT_WHITELISTED = 'NOT_WHITELISTED',
  OPT_OUT = 'OPT_OUT',
  REJECTED = 'REJECTED',
  NOT_IN_PACKAGE = 'NOT_IN_PACKAGE',
  BLOCKED_OVER_CREDIT_LIMIT = 'BLOCKED_OVER_CREDIT_LIMIT',
  DEMO_LIMIT_EXCEEDED = 'DEMO_LIMIT_EXCEEDED',
  ERROR = 'ERROR',
  RECEIVED = 'RECEIVED',
  FAILED = 'FAILED',
}

export interface ChatConversationId {
  readonly channel: SupportedChatChannel;
  readonly senderId: string;
  readonly clientId: string;
}

export interface ChatAttachment {
  readonly link: string;
  readonly filename?: string;
  readonly caption?: string;
}

export interface ChatMessage {
  readonly channel: SupportedChatChannel;
  readonly senderId: string;
  readonly clientId: string;
  readonly msgId: string;
  readonly message?: string;
  readonly date: string;
  readonly outgoing: boolean;
  readonly origin?: string;
  readonly user?: string;
  readonly payloadType: ChatMessagePayloadType;
  readonly attachments: ChatAttachment[];
  readonly status: string;
  readonly statusCode: number;
  readonly statusDetails?: string;
  readonly error: string | null;
  readonly button?: {
    readonly action: string;
    readonly caption: string;
  };
}

export type ChatMessagesPage = Page<ChatMessage>;
